<template>
    <div
        class="c-switch-list c-switch-list--address"
        :class="{
            'is-disabled': isAddressesDisabled,
            'is-initial': isInitialAddressesFetch,
        }"
    >
        <template v-if="isInitialAddressesFetch">
            <div class="c-switch-list__item" v-for="i in 2" />
        </template>

        <template v-else>
            <button
                type="button"
                class="c-switch-list__item"
                :id="address.id"
                v-for="address in filteredAddresses"
                :key="address.id"
                :class="{ 'is-selected': address.id == selectedAddressId }"
                @click="changeAddress(address.id)"
            >
                <strong class="sc-strong">
                    {{
                        address.isStorePickup
                            ? address.city
                            : $t("Switch.Addresses.courier")
                    }}
                </strong>

                <div class="sc-text" v-html="address.address" />
            </button>

            <button
                type="button"
                class="c-switch-list__item is-link"
                :class="{ 'is-active': isAllAddressesShown }"
                v-if="isAllAddressesLinkShown"
                @click="toggleAllAddresses"
            >
                <span class="sc-text">{{ otherAddressesText }}</span>
                <i class="ico ico-chevron-down" aria-hidden="true"></i>
            </button>
        </template>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
    methods: {
        changeAddress(addressId) {
            this.$store.dispatch("changeAddress", addressId);
        },
        toggleAllAddresses() {
            this.$store.commit("CHANGE_ADDRESSES_VISIBILITY");
        },
    },
    computed: {
        ...mapState([
            "selectedAddressId",
            "isInitialAddressesFetch",
            "isAddressesDisabled",
            "isAllAddressesShown",
            "shownAddressesCount",
        ]),
        ...mapGetters([
            "allAddresses",
            "filteredAddresses",
            "otherAddressesText",
            "isAllAddressesLinkShown",
        ]),
    },
};
</script>